var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "59.6195mm",
    height: "59.6195mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2644 2644",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .fil2 {fill:none}\r\n    .fil0 {fill:url(#id0)}\r\n    .fil1 {fill:url(#id1)}\r\n  ")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id0",
    gradientUnits: "userSpaceOnUse",
    x1: 524.833,
    y1: 1324.6,
    x2: 662.684,
    y2: 1324.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#999999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321569,
    style: {
      stopOpacity: 1,
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "gray"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id1",
    gradientUnits: "userSpaceOnUse",
    x1: 662.684,
    y1: 799.285,
    x2: 2494.19,
    y2: 799.285
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "red"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129412,
    style: {
      stopOpacity: 1,
      stopColor: "#FB7373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180392,
    style: {
      stopOpacity: 1,
      stopColor: "#FAA0A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278431,
    style: {
      stopOpacity: 1,
      stopColor: "#F25C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45098,
    style: {
      stopOpacity: 1,
      stopColor: "red"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741176,
    style: {
      stopOpacity: 1,
      stopColor: "#9E0000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "red"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_590828560"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    x: 525,
    y: 202,
    width: 138,
    height: 2245
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M663 202c894,-83 1094,783 1831,603 -506,699 -1355,129 -1831,597 0,-400 0,-800 0,-1200z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    width: 2644,
    height: 2644
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.d658a6ceeb5eab4886495b064c1bb049.svg";
export { ForwardRef as ReactComponent };